import { render, staticRenderFns } from "./TableRowNumErrorsPerTech.vue?vue&type=template&id=e656bc00&lang=pug&"
import script from "./TableRowNumErrorsPerTech.vue?vue&type=script&lang=js&"
export * from "./TableRowNumErrorsPerTech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e656bc00')) {
      api.createRecord('e656bc00', component.options)
    } else {
      api.reload('e656bc00', component.options)
    }
    module.hot.accept("./TableRowNumErrorsPerTech.vue?vue&type=template&id=e656bc00&lang=pug&", function () {
      api.rerender('e656bc00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/tracking-sheet/table-rows/TableRowNumErrorsPerTech.vue"
export default component.exports